import { ArchiveNodeOption } from "models/ArchiveNodeOption";
import { isGrandparentNode } from "views/documents/state/documentArchiveOptions";

import "./CustomerServiceTreeItem.scss";

type Props = {
  service: ArchiveNodeOption;
  onNodeClick: (
    service: any,
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => void;
  selectedNode: ArchiveNodeOption;
};

export default function CustomerServiceTreeItem({
  service,
  onNodeClick,
  selectedNode
}: Props) {
  const getClasses = () => {
    if (service === undefined) {
      return "";
    }
    const classes: string[] = [];
    const isExpanded =
      isChildSelected(service) || service.id === selectedNode.id;

    if (service.nodes.length === 0) {
      return "empty";
    }

    if (isExpanded) {
      classes.push("open");
    }
    if (selectedNode.id === service.id) {
      classes.push("selected");
    }

    if (isGrandparentNode(service)) {
      classes.push("folder");
    } else {
      classes.push("emptyFolder");
    }

    const className = classes.join(" ");
    return className;
  };

  const isChildSelected = (serviceItem: ArchiveNodeOption) => {
    for (const node of serviceItem.nodes) {
      if (selectedNode.id === node.id || isChildSelected(node)) {
        return true;
      }
    }
  };

  const createChildItem = () => {
    return service.nodes.map((node) => {
      return (
        <CustomerServiceTreeItem
          key={node.id}
          service={node}
          selectedNode={selectedNode}
          onNodeClick={onNodeClick}
        />
      );
    });
  };

  let children;
  let classes;
  let name;

  if (selectedNode !== undefined) {
    classes = getClasses();
  }
  if (service !== undefined && service.nodes.length > 0) {
    name = service.name;
    children = <ul>{createChildItem()}</ul>;
  }

  return (
    <li className={classes}>
      <a onClick={(e) => onNodeClick(service, e)}>
        <span>{name}</span>
      </a>
      {children}
    </li>
  );
}
